export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13323.72b1014a.jpg";